import { useMutation } from "@tanstack/react-query";
import { Spin } from "antd";
import { Outlet, useNavigate } from "react-router-dom";

import { NotifyTypeEnum } from "../../constants/notify";
import Routers from "../../constants/routers";
import { useAuth } from "../../context/AuthContext";
import { logoutApi } from "../../services/api/logoutApi";
import { completeLocalLogout } from "../../utils/auth/logout";
import { handleMutationError } from "../../utils/common/errors";
import { notify } from "../../utils/common/notify";

const MainLayout = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isBrokerAccount = user?.account_type === "broker" || user?.affiliate_type === "broker";
  const shouldShowAffiliateName = !isBrokerAccount && Boolean(user?.affiliate_name);

  const { mutate: logoutMutation, isPending: isLogoutPending } = useMutation({
    mutationFn: () => logoutApi(),
    onSuccess: (response: any) => {
      if (!response.success) {
        notify(response?.message, NotifyTypeEnum.ERROR);
      }
    },
    onError: (error: any) => {
      handleMutationError(error);
    },
    onSettled: () => {
      completeLocalLogout();
    }
  });

  const handleLogout = () => {
    logoutMutation();
  };

  return (
    <Spin spinning={isLogoutPending}>
      <div className="app-container">
        <header className="page-header">
          <button className="back-btn" onClick={() => navigate(Routers.Dashboard)}>
            ← メニューに戻る
          </button>
          <div className="header-content">
            <img src="/renpoppo-logo-trans.png" alt="れんぽっぽ Logo" className="header-logo-main" />
            <h1>加盟店システム</h1>
          </div>
          <div className="header-actions">
            {shouldShowAffiliateName ? (
              <div className="header-account-badge">加盟店: {user?.affiliate_name}</div>
            ) : null}
            <button className="logout-btn-header" onClick={handleLogout}>
              ログアウト
            </button>
          </div>
        </header>

        <main className="page-main">
          <Outlet />
        </main>
      </div>
    </Spin>
  );
};

export default MainLayout;
